import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'
import { deleteSinglePrice, modifySinglePrice } from '../actions/calendars'
import LoadingProgress from './LoadingProgress'
import '../styles/CalendarDetailsView.css'

class Calendar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPriceEntry: null,      // The price entry currently open for inline edit
      editingPriceId: null,          // Id of the price being edited inline
      newPrice: '',                  // Current inline input value
      confirmingDeleteId: null,      // Id of the price pending delete confirmation
      selectedDayEntry: null,
      selectedMonthEntry: null,
      selectedYearEntry: null,
      collapsedMonths: {},
      weatherModalOpen: false,
      weatherModalDay: null,   // { dateStr, w, priceData }
    };
  }

  generateCalendarDays(month, year) {
    const days = [];
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    let firstDayIndex = firstDate.getDay();

    // Adjust firstDayIndex so that 0 represents Monday
    firstDayIndex = (firstDayIndex === 0) ? 6 : firstDayIndex - 1;

    // Add empty slots for the days before the first day of the month
    for (let i = 0; i < firstDayIndex; i++) {
      days.push({ day: null });
    }

    // Add the actual days of the month
    for (let i = 1; i <= lastDate.getDate(); i++) {
      const dayDate = new Date(year, month, i);

      // Correct way to compare dates (ignoring time)
      const priceData = this.props.priceCalendar.find(
        (entry) => {
          const entryDate = new Date(entry.date);
          return (
            entryDate.getDate() === dayDate.getDate() &&
            entryDate.getMonth() === dayDate.getMonth() &&
            entryDate.getFullYear() === dayDate.getFullYear()
          );
        }
      );

      days.push({ day: i, priceData });
    }

    return days;
  }

  getZoneNameOld(zone) {

    switch (zone) {
      case 0:
        return 'GENERAL';
      case 1:
        return 'BAQUEIRA';
      case 2:
        return 'BERET';
      case 3:
        return 'BONAIGUA';
      case 4:
        return 'RUDA';
      case 5:
        return 'BOSQUE';
      default:
        return 'NONE';
    }
  }

  getZoneName(zone) {
    const { customer } = this.props;
    if (!customer || !customer.Zones) return 'NONE';

    const foundZone = customer.Zones.find(z => z.Zone === zone);
    return foundZone ? foundZone.Description : 'NONE';
  }

  getZoneColor(zone) {

    switch (zone) {
      case 0:
        return 'bg-primary';
      case 1:
        return 'bg-white';
      case 2:
        return 'bg-success';
      case 3:
        return 'bg-info';
      case 4:
        return 'bg-warning';
      case 5:
        return 'bg-secondary';
      default:
        return 'bg-danger';
    }
  }

  getWeatherInfo(code) {
    if (code === null || code === undefined) return null;
    if (code === 0)  return { icon: 'fa-sun',                color: '#f59e0b', label: 'Despejado' };
    if (code <= 1)   return { icon: 'fa-sun',                color: '#f59e0b', label: 'Principalmente despejado' };
    if (code <= 2)   return { icon: 'fa-cloud-sun',          color: '#fbbf24', label: 'Parcialmente nublado' };
    if (code === 3)  return { icon: 'fa-cloud',              color: '#9ca3af', label: 'Cubierto' };
    if (code <= 48)  return { icon: 'fa-smog',               color: '#6b7280', label: 'Niebla' };
    if (code <= 55)  return { icon: 'fa-cloud-rain',         color: '#60a5fa', label: 'Llovizna' };
    if (code <= 67)  return { icon: 'fa-cloud-rain',         color: '#3b82f6', label: 'Lluvia' };
    if (code <= 77)  return { icon: 'fa-snowflake',          color: '#93c5fd', label: 'Nieve' };
    if (code <= 82)  return { icon: 'fa-cloud-showers-heavy',color: '#2563eb', label: 'Chubascos' };
    if (code <= 86)  return { icon: 'fa-snowflake',          color: '#bfdbfe', label: 'Nieve intensa' };
    if (code >= 95)  return { icon: 'fa-bolt',               color: '#7c3aed', label: 'Tormenta' };
    return { icon: 'fa-cloud', color: '#9ca3af', label: '' };
  }

  getWeatherCategory(code) {
    if (code === null || code === undefined) return null;
    if (code <= 2)  return 'sunny';
    if (code === 3) return 'cloudy';
    if (code <= 48) return 'foggy';
    if (code <= 67) return 'rainy';
    if (code <= 77) return 'snowy';
    if (code <= 82) return 'showery';
    if (code >= 95) return 'stormy';
    return 'cloudy';
  }

  buildWeatherPriceAnalysis() {
    const { priceCalendar, weatherData, startMonth, endMonth, startYear, endYear } = this.props;
    if (!weatherData || !priceCalendar || Object.keys(weatherData).length === 0) return null;

    const dayData = [];
    priceCalendar.forEach(entry => {
      const dateStr = typeof entry.date === 'string'
        ? entry.date.split('T')[0]
        : new Date(entry.date).toISOString().split('T')[0];
      const parts = dateStr.split('-');
      const y  = parseInt(parts[0], 10);
      const mo = parseInt(parts[1], 10) - 1;
      let inRange = false;
      if (startYear === endYear) {
        inRange = y === startYear && mo >= startMonth && mo <= endMonth;
      } else if (y === startYear) {
        inRange = mo >= startMonth;
      } else if (y === endYear) {
        inRange = mo <= endMonth;
      } else {
        inRange = y > startYear && y < endYear;
      }
      if (!inRange) return;
      const w = weatherData[dateStr];
      if (!w || w.code === null) return;
      const cat = this.getWeatherCategory(w.code);
      if (!cat) return;
      dayData.push({ date: dateStr, cat, code: w.code, tmax: w.tmax, tmin: w.tmin, precip: w.precip, prices: entry.prices || [] });
    });
    if (dayData.length === 0) return null;

    const catCounts = {};
    dayData.forEach(d => { catCounts[d.cat] = (catCounts[d.cat] || 0) + 1; });

    const typeMap = {};
    dayData.forEach(({ cat, prices }) => {
      prices.forEach(p => {
        if (typeof p.price !== 'number') return;
        const key = `${p.zone}:${p.type}`;
        if (!typeMap[key]) {
          typeMap[key] = {
            zone: p.zone, type: p.type,
            zoneName: this.getZoneName(p.zone),
            typeName: this.getTypeName(p.type),
            cats: {},
          };
        }
        if (!typeMap[key].cats[cat]) typeMap[key].cats[cat] = [];
        typeMap[key].cats[cat].push(p.price);
      });
    });

    const avg = arr => arr.length ? arr.reduce((s, v) => s + v, 0) / arr.length : null;
    const dirOrder = { up: 0, neutral: 1, ok: 2, info: 3 };

    const recommendations = Object.values(typeMap).map(item => {
      const { cats, zoneName, typeName, zone, type } = item;
      const goodArr = [...(cats.sunny || []), ...(cats.cloudy || [])];
      const badArr  = [...(cats.rainy || []), ...(cats.showery || []), ...(cats.stormy || [])];
      const snowArr = cats.snowy || [];
      const allArr  = Object.values(cats).flat();
      const goodAvg = avg(goodArr), badAvg = avg(badArr), snowAvg = avg(snowArr), overallAvg = avg(allArr);

      let direction = 'info', recommendation = '';
      if (goodAvg !== null && badAvg !== null) {
        const diff    = goodAvg - badAvg;
        const diffPct = Math.abs(diff / badAvg * 100);
        if (diff < -0.5) {
          direction = 'up';
          recommendation = `Los días soleados tienen precio medio más bajo (${goodAvg.toFixed(2)}€) que en días de lluvia (${badAvg.toFixed(2)}€). Considera subir precios en buen tiempo — la demanda suele ser mayor.`;
        } else if (diff > 0.5 && diffPct > 5) {
          direction = 'ok';
          recommendation = `Buena diferenciación climática: ${goodAvg.toFixed(2)}€ en días buenos vs. ${badAvg.toFixed(2)}€ en días lluviosos (+${diffPct.toFixed(0)}%). Estrategia de precios optimizada.`;
        } else {
          direction = 'neutral';
          recommendation = `Precio uniforme (≈${overallAvg?.toFixed(2)}€) sin diferenciación climática. Considera tarifas dinámicas: precios más altos en días buenos y menores en días de lluvia para mantener la ocupación.`;
        }
      } else if (goodAvg !== null) {
        direction = 'info';
        recommendation = `Solo hay datos de días de buen tiempo (media ${goodAvg.toFixed(2)}€). Sin días lluviosos en el rango para comparar.`;
      } else if (badAvg !== null) {
        direction = 'info';
        recommendation = `Solo hay datos de días lluviosos (media ${badAvg.toFixed(2)}€). Sin días soleados en el rango para comparar.`;
      }
      if (snowArr.length > 0) {
        const extra = snowAvg > (overallAvg || 0)
          ? ` En días de nieve el precio es superior (${snowAvg.toFixed(2)}€) — correcto para alta demanda invernal.`
          : ` Los días de nieve tienen precio similar a la media (${snowAvg.toFixed(2)}€). Podría subirse dado el alto flujo invernal.`;
        recommendation += extra;
      }
      if (!recommendation) {
        recommendation = `Precio medio: ${overallAvg?.toFixed(2) || '—'}€. Datos climáticos insuficientes para una recomendación detallada.`;
        direction = 'info';
      }
      return { zone, type, zoneName, typeName, goodAvg, badAvg, snowAvg, overallAvg, direction, recommendation };
    });
    recommendations.sort((a, b) => (dirOrder[a.direction] ?? 4) - (dirOrder[b.direction] ?? 4));
    return { dayData, catCounts, recommendations, totalDays: dayData.length };
  }

  getTypeName(type) {
    const { category } = this.props;

    if (category === 'BAQUEIRA') {
      switch (type) {
        case 'BN3XL':
          return '2 PAX';
        case 'CN3XL':
          return '3 PAX';
        case 'BW3XL':
          return '4 PAX';
        default:
          return 'NONE';
      }
    } else {
      switch (type) {
        case 'BNS':
          return 'Standard';
        case 'CNS':
          return 'Standard Carga';
        case 'BWS':
          return 'Standard XL';
        case 'CWS':
          return 'Standard Carga XL';
        case 'BNM':
          return 'Medium';
        case 'CNM':
          return 'Medium Carga';
        case 'BWM':
          return 'Medium XL';
        case 'CWM':
          return 'Medium Carga XL';
        case 'BNL':
          return 'Large';
        case 'CNL':
          return 'Large Carga';
        case 'BWL':
          return 'Large XL';
        case 'CWL':
          return 'Large Carga XL';
        case 'BNXL':
          return 'Large 4';
        case 'CNXL':
          return 'Large 4 Carga';
        case 'BWXL':
          return 'Large 4 XL';
        case 'CWXL':
          return 'Large 4 Carga XL';
        case 'BN2XL':
          return 'Large 5';
        case 'CN2XL':
          return 'Large 5 Carga';
        case 'BW2XL':
          return 'Large 5 XL';
        case 'CW2XL':
          return 'Large 5 Carga XL';
        case 'BN3XL':
          return 'Ski';
        case 'CN3XL':
          return 'Ski Carga';
        case 'BW3XL':
          return 'Ski XL';
        case 'CW3XL':
          return 'Ski Carga XL';
        // Voucher/Coupon Types (X and W, no LOCKER prefix)
        case 'XNS':
          return 'Standard Cupón';
        case 'XWS':
          return 'Standard XL Cupón';
        case 'XNM':
          return 'Medium Cupón';
        case 'XWM':
          return 'Medium XL Cupón';
        case 'XNL':
          return 'Large Cupón';
        case 'XWL':
          return 'Large XL Cupón';
        case 'XNXL':
          return 'Large 4 Cupón';
        case 'XWXL':
          return 'Large 4 XL Cupón';
        case 'XN2XL':
          return 'Large 5 Cupón';
        case 'XW2XL':
          return 'Large 5 XL Cupón';
        case 'XN3XL':
          return 'Ski Cupón';
        case 'XW3XL':
          return 'Ski XL Cupón';
        default:
          return 'NONE';
      }
    }
  }

  // Begin inline modification of a price (renders an input inside the cell)
  handleStartModify = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: price._id,
      newPrice: price.price,
      confirmingDeleteId: null,
    });
  };

  // Confirm inline deletion
  handleConfirmDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.props.deleteSinglePrice(price._id);
    this.setState({
      confirmingDeleteId: null,
      selectedPriceEntry: null,
      editingPriceId: null,
      newPrice: '',
    });
  };

  // Ask for delete confirmation inline
  handleAskDelete = (e, price) => {
    if (e) e.stopPropagation();
    this.setState({
      confirmingDeleteId: price._id,
      editingPriceId: null,
    });
  };

  // Submit inline modification
  handleConfirmModify = (e, price) => {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    const { newPrice } = this.state;
    if (newPrice === '' || isNaN(parseFloat(newPrice))) return;
    this.props.modifySinglePrice(price._id, parseFloat(newPrice));
    this.setState({
      editingPriceId: null,
      selectedPriceEntry: null,
      newPrice: '',
    });
  };

  // Cancel inline edit / delete-confirm
  handleCancelInline = (e) => {
    if (e) e.stopPropagation();
    this.setState({
      editingPriceId: null,
      confirmingDeleteId: null,
      newPrice: '',
    });
  };

  toggleMonth = (key) => {
    this.setState(prev => ({
      collapsedMonths: { ...prev.collapsedMonths, [key]: !prev.collapsedMonths[key] }
    }));
  };

  handlePriceChange = (event) => {
    this.setState({ newPrice: event.target.value });
  };

  getWeatherCatMeta(cat) {
    const map = {
      sunny:   { icon: 'fa-sun',                 color: '#f59e0b', label: 'Soleado'   },
      cloudy:  { icon: 'fa-cloud',               color: '#94a3b8', label: 'Nublado'   },
      foggy:   { icon: 'fa-smog',                color: '#6b7280', label: 'Niebla'    },
      rainy:   { icon: 'fa-cloud-rain',          color: '#3b82f6', label: 'Lluvia'    },
      snowy:   { icon: 'fa-snowflake',           color: '#60a5fa', label: 'Nieve'     },
      showery: { icon: 'fa-cloud-showers-heavy', color: '#2563eb', label: 'Chubascos' },
      stormy:  { icon: 'fa-bolt',               color: '#7c3aed', label: 'Tormenta'  },
    };
    return map[cat] || { icon: 'fa-cloud', color: '#9ca3af', label: cat };
  }

  renderWeatherModal() {
    const { weatherModalOpen, weatherModalDay } = this.state;
    if (!weatherModalOpen || !weatherModalDay) return null;
    const { dateStr, w, priceData } = weatherModalDay;
    const weatherInfo = this.getWeatherInfo(w.code);
    const cat = this.getWeatherCategory(w.code);

    // Build per-type recommendations based solely on this day's weather
    const isGood  = ['sunny', 'cloudy'].includes(cat);
    const isBad   = ['rainy', 'showery', 'stormy'].includes(cat);
    const isSnow  = cat === 'snowy';
    const isFog   = cat === 'foggy';

    // Build demand context sentence from weather
    const demandText = isGood
      ? 'El buen tiempo favorece alta demanda — es buen momento para mantener o subir tarifas.'
      : isBad
        ? 'La lluvia o tormenta puede reducir la demanda espontánea — valora descuentos o tarifas dinámicas.'
        : isSnow
          ? 'La nieve puede atraer un perfil de cliente específico — asegúrate de tener tarifa nieve configurada.'
          : isFog
            ? 'La niebla puede reducir la visibilidad y afluencia. Mantén precios competitivos.'
            : 'Condiciones mixtas — mantén las tarifas habituales.';

    // Generate per-type recs if priceData exists
    const typeRecs = priceData && priceData.prices
      ? priceData.prices.map(p => {
          const typeName = this.getTypeName(p.type);
          const zoneName = this.getZoneName(p.zone);
          let advice, icon, color;
          if (isGood) {
            advice = `Con buen tiempo la demanda es alta — el precio actual de ${p.price.toFixed(2)}€ es adecuado o podría subirse ligeramente.`;
            icon = 'fa-arrow-trend-up'; color = '#16a34a';
          } else if (isBad) {
            advice = `Días de lluvia/tormenta: considera una tarifa reducida o promo para impulsar ocupación. Precio actual: ${p.price.toFixed(2)}€.`;
            icon = 'fa-tag'; color = '#2563eb';
          } else if (isSnow) {
            advice = `Día de nieve: tarifa diferenciada recomendada. Precio actual: ${p.price.toFixed(2)}€ — revisa si tienes tarifa nieve específica.`;
            icon = 'fa-snowflake'; color = '#0ea5e9';
          } else {
            advice = `Condiciones neutras — precio actual ${p.price.toFixed(2)}€ dentro de lo esperado.`;
            icon = 'fa-equals'; color = '#64748b';
          }
          return { zoneName, typeName, price: p.price, advice, icon, color };
        })
      : [];

    // Format date nicely
    const dateParts = dateStr.split('-');
    const dateObj = new Date(Date.UTC(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2])));
    const dateLabel = dateObj.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    const isForecast = dateStr >= new Date().toISOString().split('T')[0];

    return (
      <div className="weather-modal-overlay" onClick={() => this.setState({ weatherModalOpen: false, weatherModalDay: null })}>
        <div className="weather-modal" onClick={e => e.stopPropagation()}>
          <div className="weather-modal-header">
            <div className="weather-modal-title">
              <i className="fas fa-robot" style={{color:'#7dd3fc'}}></i>
              Análisis del día &middot; <span style={{textTransform:'capitalize'}}>{dateLabel}</span>
            </div>
            <button className="weather-modal-close" onClick={() => this.setState({ weatherModalOpen: false, weatherModalDay: null })}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="weather-modal-body">
            {/* Day weather summary */}
            <div className="wm-day-summary">
              <div className="wm-day-weather">
                <i className={`fas ${weatherInfo.icon} wm-day-icon`} style={{ color: weatherInfo.color }}></i>
                <div className="wm-day-info">
                  <span className="wm-day-label">{weatherInfo.label}</span>
                  <div className="wm-day-temps">
                    {w.tmax != null && <span className="wm-tmax">{Math.round(w.tmax)}°C máx</span>}
                    {w.tmin != null && <span className="wm-tmin">{Math.round(w.tmin)}°C mín</span>}
                    {w.precip != null && w.precip > 0 && <span className="wm-precip"><i className="fas fa-tint"></i> {w.precip.toFixed(1)} mm</span>}
                  </div>
                </div>
                {isForecast && <span className="wm-forecast-badge"><i className="fas fa-broadcast-tower mr-1"></i>Previsión</span>}
              </div>
              <div className="wm-demand-text">
                <i className="fas fa-robot wm-intro-icon"></i>
                <p>{demandText}</p>
              </div>
            </div>

            <div className="wm-disclaimer">
              <i className="fas fa-info-circle mr-1"></i>
              {isForecast
                ? 'Previsión meteorológica de Open-Meteo (hasta 15 días). Las recomendaciones son orientativas.'
                : 'Datos históricos de Open-Meteo. Las recomendaciones son orientativas.'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handlePriceEntryClick = (price, day, month, year) => {
    const wasSelected = this.state.selectedPriceEntry === price;
    this.setState({
      selectedPriceEntry: wasSelected ? null : price,
      selectedDayEntry: day,
      selectedMonthEntry: month,
      selectedYearEntry: year,
      // closing the entry also closes any inline editor on it
      editingPriceId: wasSelected ? null : this.state.editingPriceId,
      confirmingDeleteId: wasSelected ? null : this.state.confirmingDeleteId,
    });
  };

  render() {
    const { startYear, endYear, startMonth, endMonth, customer, loading, weatherData, weatherLocation } = this.props;
    const { selectedPriceEntry, editingPriceId, confirmingDeleteId, newPrice, collapsedMonths } = this.state;

    const pad = n => String(n).padStart(2, '0');
    const todayStr = new Date().toISOString().split('T')[0];

    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Determine the range of months to display
    const monthsToDisplay = [];
    
    // If years are the same, only show months in that year
    if (startYear === endYear) {
      for (let i = startMonth; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
    } else {
      // Show months from startMonth to December in startYear
      for (let i = startMonth; i <= 11; i++) {
        monthsToDisplay.push({ month: i, year: startYear });
      }
      
      // Show months for any full years in between
      for (let year = startYear + 1; year < endYear; year++) {
        for (let i = 0; i <= 11; i++) {
          monthsToDisplay.push({ month: i, year });
        }
      }
      
      // Show months from January to endMonth in endYear
      for (let i = 0; i <= endMonth; i++) {
        monthsToDisplay.push({ month: i, year: endYear });
      }
    }

    if (!customer) {
      return <LoadingProgress />
    }

    return (
      <div className="calendar-wrapper">
        {loading && (
          <div className="calendar-loading-overlay">
            <div className="calendar-spinner"></div>
          </div>
        )}
        {monthsToDisplay.map(({ month, year }) => {
          const days = this.generateCalendarDays(month, year);
          const hasPrices = days.some(day => day.priceData);

          if (!hasPrices) return null;

          const monthPrices = days.reduce((acc, d) => {
            if (d.priceData && d.priceData.prices) {
              d.priceData.prices.forEach(p => { if (p && typeof p.price === 'number') acc.push(p.price); });
            }
            return acc;
          }, []);
          const totalDays = days.filter(d => d.priceData).length;
          const mMin = monthPrices.length ? Math.min(...monthPrices) : null;
          const mMax = monthPrices.length ? Math.max(...monthPrices) : null;
          const mAvg = monthPrices.length ? (monthPrices.reduce((s, v) => s + v, 0) / monthPrices.length) : null;
          const fmtM = v => v === null ? '—' : v.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });

          const key = `${month}-${year}`;
          const isCollapsed = !!collapsedMonths[key];

          return (
            <div key={key} className="calendar">
              <div className="calendar-month-header">
                <span className="calendar-month-title">
                  <i className="fas fa-calendar-alt mr-2"></i>{monthNames[month]} {year}
                </span>
                <div className="calendar-month-stats">
                  <span className="month-stat-pill"><i className="fas fa-calendar-check mr-1"></i>{totalDays} días</span>
                  <span className="month-stat-pill low"><i className="fas fa-arrow-down mr-1"></i>{fmtM(mMin)}</span>
                  <span className="month-stat-pill avg"><i className="fas fa-minus mr-1"></i>{fmtM(mAvg)}</span>
                  <span className="month-stat-pill high"><i className="fas fa-arrow-up mr-1"></i>{fmtM(mMax)}</span>
                  <button className="month-collapse-btn" onClick={() => this.toggleMonth(key)}>
                    {isCollapsed
                      ? <span key="closed"><i className="fas fa-chevron-down mr-1"></i>Mostrar</span>
                      : <span key="open"><i className="fas fa-chevron-up mr-1"></i>Ocultar</span>
                    }
                  </button>
                </div>
              </div>
              {!isCollapsed && (
              <div className="calendar-grid">
                {['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'].map((day) => (
                  <div key={day} className="calendar-day-header">{day}</div>
                ))}
                {days.map((day, index) => {
                  const dayStr = day.day ? `${year}-${pad(month + 1)}-${pad(day.day)}` : null;
                  const w = dayStr && weatherData ? weatherData[dayStr] : null;
                  const weatherInfo = w ? this.getWeatherInfo(w.code) : null;
                  return (
                  <div
                    key={index}
                    className={`calendar-operator-day ${day.day ? (day.priceData ? 'with-price' : 'no-price') : 'no-day'}`}>
                    {day.day && (
                      <>
                        <div className="day-header-row">
                          <span className="day-number-badge">{day.day}</span>
                          {weatherInfo && (
                            <button
                              className="day-weather-btn"
                              title={`${weatherInfo.label}${w.tmax != null ? ` · ${Math.round(w.tmax)}°/${w.tmin != null ? Math.round(w.tmin) : '?'}°C` : ''}${w.precip > 0 ? ` · ${w.precip.toFixed(1)} mm` : ''} — Clic para análisis`}
                              onClick={(e) => { e.stopPropagation(); this.setState({ weatherModalOpen: true, weatherModalDay: { dateStr: dayStr, w, priceData: day.priceData || null } }); }}
                            >
                              <i className={`fas ${weatherInfo.icon} dwb-icon`} style={{ color: weatherInfo.color }}></i>
                              {w.tmax != null && <span className="dwb-tmax">{Math.round(w.tmax)}°</span>}
                              {w.tmin != null && <span className="dwb-tmin">/{Math.round(w.tmin)}°</span>}
                              {w.precip != null && w.precip > 0 && (
                                <span className="dwb-precip"><i className="fas fa-tint"></i>{w.precip.toFixed(1)}</span>
                              )}
                              <span className="dwb-hint"><i className="fas fa-robot mr-1"></i>Analizar</span>
                            </button>
                          )}
                        </div>
                        {day.priceData && (
                          <div className="price-info">
                            {day.priceData.prices
                              .slice() // Create a shallow copy of the array to avoid mutating the original array
                              .sort((a, b) => {
                                const nameA = this.getZoneName(a.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                const nameB = this.getZoneName(b.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                                if (nameA < nameB) return -1;
                                if (nameA > nameB) return 1;
                                return 0;
                              })
                              .map((price, idx) => {
                                const isEditing = editingPriceId === price._id;
                                const isConfirmingDelete = confirmingDeleteId === price._id;
                                const isSelected = selectedPriceEntry === price;
                                const dayStr = `${year}-${pad(month + 1)}-${pad(day.day)}`;
                                const isPast = dayStr < todayStr;
                                return (
                                  <div
                                    key={idx}
                                    className={`price-entry ${this.getZoneColor(price.zone)}`}
                                    onClick={() => !isEditing && !isConfirmingDelete && this.handlePriceEntryClick(price, day.day, month, year)}
                                  >
                                    {!isEditing && !isConfirmingDelete && (
                                      <span className="price-entry-content">
                                        <span className="price-entry-zone">{this.getZoneName(price.zone).length > 12 ? this.getZoneName(price.zone).slice(0, 12) + '…' : this.getZoneName(price.zone)}</span>
                                        <span className="price-entry-sep">·</span>
                                        <span className="price-entry-type">{this.getTypeName(price.type)}</span>
                                        <span className="price-entry-sep">·</span>
                                        <span className="price-entry-amount">{(price.price).toFixed(2)}€</span>
                                      </span>
                                    )}

                                    {isEditing && (
                                      <form
                                        onSubmit={(e) => this.handleConfirmModify(e, price)}
                                        onClick={(e) => e.stopPropagation()}
                                        className="price-inline-edit"
                                      >
                                        <div className="price-inline-label">
                                          {this.getZoneName(price.zone)} · {this.getTypeName(price.type)}
                                        </div>
                                        <input
                                          type="number"
                                          step="0.01"
                                          autoFocus
                                          required
                                          value={newPrice}
                                          onChange={this.handlePriceChange}
                                          onClick={(e) => e.stopPropagation()}
                                          className="price-inline-input"
                                        />
                                        <div className="price-inline-actions">
                                          <button type="submit" className="price-action-btn confirm" title="Guardar">
                                            <i className="fas fa-check mr-1"></i>Guardar
                                          </button>
                                          <button type="button" className="price-action-btn cancel" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times mr-1"></i>Cancelar
                                          </button>
                                        </div>
                                      </form>
                                    )}

                                    {isConfirmingDelete && (
                                      <div className="price-inline-edit" onClick={(e) => e.stopPropagation()}>
                                        <div className="price-inline-label danger">¿Eliminar este precio?</div>
                                        <div className="price-inline-actions">
                                          <button type="button" className="price-action-btn danger" title="Sí, eliminar" onClick={(e) => this.handleConfirmDelete(e, price)}>
                                            <i className="fas fa-trash mr-1"></i>Eliminar
                                          </button>
                                          <button type="button" className="price-action-btn cancel" title="Cancelar" onClick={this.handleCancelInline}>
                                            <i className="fas fa-times mr-1"></i>Cancelar
                                          </button>
                                        </div>
                                      </div>
                                    )}

                                    {isSelected && !isEditing && !isConfirmingDelete && (
                                      isPast ? (
                                        <div className="price-past-notice">
                                          <i className="fas fa-lock mr-1"></i>No se pueden modificar precios de fechas pasadas
                                        </div>
                                      ) : (
                                      <div className="price-inline-actions mt-1">
                                        <button className="price-action-btn edit" onClick={(e) => this.handleStartModify(e, price)}>
                                          <i className="fas fa-pen mr-1"></i>Modificar
                                        </button>
                                        <button className="price-action-btn danger" onClick={(e) => this.handleAskDelete(e, price)}>
                                          <i className="fas fa-trash mr-1"></i>Eliminar
                                        </button>
                                      </div>
                                      )
                                    )}
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  );
                })}
              </div>
              )}
            </div>
          );
        })}
        {this.renderWeatherModal()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  priceCalendar: state.calendars.calendar.PriceCalendar,
  calendar: state.calendars.calendar,
  category: state.auth.category,
  loading: state.calendars.loading,
  error: state.calendars.error,
});

const mapDispatchToProps = dispatch => ({
  deleteSinglePrice: bindActionCreators(deleteSinglePrice, dispatch),
  modifySinglePrice: bindActionCreators(modifySinglePrice, dispatch),
  push: bindActionCreators(push, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);